"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandName = void 0;
/**
 * BrandName corresponds to the brand of products we sell to customers.
 * This enum is a subset of the Brand entities in the database.
 * It is used to trigger business logic based on specific brands.
 * Therefore it does not have to be an exhaustive list, but only updated/extended occasionally when needed
 */
var BrandName;
(function (BrandName) {
    BrandName["Airflex"] = "Airflex";
    BrandName["Astronergy"] = "Astronergy";
    BrandName["ATAG"] = "ATAG";
    BrandName["ATI"] = "ATI";
    BrandName["AUO"] = "AUO";
    BrandName["Autarco"] = "Autarco";
    BrandName["BASF"] = "BASF";
    BrandName["Clickfit"] = "Clickfit";
    BrandName["Covestro"] = "Covestro";
    BrandName["Daikin"] = "Daikin";
    BrandName["Denim"] = "Denim";
    BrandName["DMEGC"] = "DMEGC";
    BrandName["Drowa"] = "Drowa";
    BrandName["ECOSE"] = "ECOSE";
    BrandName["Enphase"] = "Enphase";
    BrandName["EnveriFoam"] = "EnveriFoam";
    BrandName["ESDEC"] = "ESDEC";
    BrandName["EXASUN"] = "EXASUN";
    BrandName["Flatfix"] = "Flatfix";
    BrandName["Fronius"] = "Fronius";
    BrandName["GLASSOLUTIONSSaintGobain"] = "GLASSOLUTIONSSaintGobain";
    BrandName["GoodWe"] = "GoodWe";
    BrandName["Growatt"] = "Growatt";
    BrandName["HanoverSolar"] = "HanoverSolar";
    BrandName["HEPRO"] = "HEPRO";
    BrandName["Honeywell"] = "Honeywell";
    BrandName["Huawei"] = "Huawei";
    BrandName["Hyundai"] = "Hyundai";
    BrandName["Icynene"] = "Icynene";
    BrandName["Intergas"] = "Intergas";
    BrandName["IsoBouw"] = "IsoBouw";
    BrandName["Isover"] = "Isover";
    BrandName["JASolar"] = "JASolar";
    BrandName["JinkoSolar"] = "JinkoSolar";
    BrandName["Kingspan"] = "Kingspan";
    BrandName["Knauf"] = "Knauf";
    BrandName["LG"] = "LG";
    BrandName["LONGi"] = "LONGi";
    BrandName["Nefit"] = "Nefit";
    BrandName["Neopixels"] = "Neopixels";
    BrandName["Nestaan"] = "Nestaan";
    BrandName["NIBE"] = "NIBE";
    BrandName["Omnik"] = "Omnik";
    BrandName["PhonoSolar"] = "PhonoSolar";
    BrandName["PIF"] = "PIF";
    BrandName["Pluimers"] = "Pluimers";
    BrandName["Qcells"] = "Qcells";
    BrandName["RaabKarcher"] = "RaabKarcher";
    BrandName["REC"] = "REC";
    BrandName["Remeha"] = "Remeha";
    BrandName["Rockwool"] = "Rockwool";
    BrandName["Sharp"] = "Sharp";
    BrandName["SMA"] = "SMA";
    BrandName["SolarEdge"] = "SolarEdge";
    BrandName["SOLARWATT"] = "SOLARWATT";
    BrandName["SolaX"] = "SolaX";
    BrandName["Solis"] = "Solis";
    BrandName["Steca"] = "Steca";
    BrandName["SunPower"] = "SunPower";
    BrandName["Suntech"] = "Suntech";
    BrandName["SUPAFIL"] = "SUPAFIL";
    BrandName["Techneco"] = "Techneco";
    BrandName["Technisol"] = "Technisol";
    BrandName["Tonzon"] = "Tonzon";
    BrandName["Trannergy"] = "Trannergy";
    BrandName["Trifoil"] = "Trifoil";
    BrandName["TrinaSolar"] = "TrinaSolar";
    BrandName["Vaillant"] = "Vaillant";
    BrandName["Winaico"] = "Winaico";
    BrandName["WOLF"] = "WOLF";
    BrandName["Xtratherm"] = "Xtratherm";
    BrandName["NONE"] = "NONE";
})(BrandName = exports.BrandName || (exports.BrandName = {}));
